"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Copyright_1 = __importDefault(require("./Copyright"));
const useDeviceBasedSrcSet_1 = require("./useDeviceBasedSrcSet");
const BaseImage = styled_components_1.default.img(({ clickable, desaturated }) => (Object.assign(Object.assign({}, (clickable
    ? {
        cursor: 'pointer',
    }
    : {})), (!desaturated && typeof desaturated === 'boolean'
    ? {
        filter: 'saturate(0.7)',
    }
    : {}))));
const Image = props => {
    const { resized, alt, src, testId, copyright } = props;
    const { defaultSrc, srcSet } = (0, useDeviceBasedSrcSet_1.useDeviceBasedSrcSet)(resized, src);
    const { lazy = true } = props;
    const imageProps = Object.assign({ loading: lazy ? 'lazy' : undefined }, props);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(BaseImage, Object.assign({ clickable: !!imageProps.onClick }, imageProps, { alt: alt, srcSet: srcSet, src: defaultSrc, "data-id": testId })),
        copyright && react_1.default.createElement(Copyright_1.default, null, copyright)));
};
exports.default = Image;
//# sourceMappingURL=Image.js.map